// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/customers.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DB } from "./db";

export const protobufPackage = "carbon.portal.customers";

/** A machine family a customer owns, derived from its robots' serials. */
export enum Product {
  /** LASERWEEDER - bud, slayer, reaper and devserver serials */
  LASERWEEDER = 0,
  /** CARBON_AUTONOMY - tractor and devserver serials */
  CARBON_AUTONOMY = 1,
  UNRECOGNIZED = -1,
}

export function productFromJSON(object: any): Product {
  switch (object) {
    case 0:
    case "LASERWEEDER":
      return Product.LASERWEEDER;
    case 1:
    case "CARBON_AUTONOMY":
      return Product.CARBON_AUTONOMY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Product.UNRECOGNIZED;
  }
}

export function productToJSON(object: Product): string {
  switch (object) {
    case Product.LASERWEEDER:
      return "LASERWEEDER";
    case Product.CARBON_AUTONOMY:
      return "CARBON_AUTONOMY";
    case Product.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CustomerResponse {
  db: DB | undefined;
  name: string;
  /** @deprecated */
  sfdcAccountId: string;
  emails: string[];
  featureFlags: { [key: string]: boolean };
  weeklyReportHour: number;
  weeklyReportDay: number;
  weeklyReportEnabled: boolean;
  weeklyReportLookbackDays: number;
  weeklyReportTimezone: string;
  /**
   * Use products_used.
   *
   * @deprecated
   */
  hasAtk?: boolean | undefined;
  uuid: string;
  /** Carbon owns this customer. Unset leaves it unchanged on update. */
  isCarbon?:
    | boolean
    | undefined;
  /** Products the customer owns at least one robot of, sorted, no duplicates. */
  productsUsed: Product[];
}

export interface CustomerResponse_FeatureFlagsEntry {
  key: string;
  value: boolean;
}

export interface Customer {
  uuid: string;
  name: string;
}

export interface ListCustomersRequest {
  /**
   * Cursor from `ListCustomersResponse.next_page_token` on a previous response.
   * If blank, starts from the beginning.
   */
  pageToken: string;
}

export interface ListCustomersResponse {
  customers: Customer[];
  /**
   * Cursor for `ListCustomersRequest.page_token`. If blank, there are no
   * further pages.
   */
  nextPageToken: string;
}

function createBaseCustomerResponse(): CustomerResponse {
  return {
    db: undefined,
    name: "",
    sfdcAccountId: "",
    emails: [],
    featureFlags: {},
    weeklyReportHour: 0,
    weeklyReportDay: 0,
    weeklyReportEnabled: false,
    weeklyReportLookbackDays: 0,
    weeklyReportTimezone: "",
    hasAtk: undefined,
    uuid: "",
    isCarbon: undefined,
    productsUsed: [],
  };
}

export const CustomerResponse: MessageFns<CustomerResponse> = {
  encode(message: CustomerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.db !== undefined) {
      DB.encode(message.db, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.sfdcAccountId !== "") {
      writer.uint32(26).string(message.sfdcAccountId);
    }
    for (const v of message.emails) {
      writer.uint32(34).string(v!);
    }
    globalThis.Object.entries(message.featureFlags).forEach(([key, value]: [string, boolean]) => {
      CustomerResponse_FeatureFlagsEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    if (message.weeklyReportHour !== 0) {
      writer.uint32(48).int64(message.weeklyReportHour);
    }
    if (message.weeklyReportDay !== 0) {
      writer.uint32(56).int64(message.weeklyReportDay);
    }
    if (message.weeklyReportEnabled !== false) {
      writer.uint32(64).bool(message.weeklyReportEnabled);
    }
    if (message.weeklyReportLookbackDays !== 0) {
      writer.uint32(72).int64(message.weeklyReportLookbackDays);
    }
    if (message.weeklyReportTimezone !== "") {
      writer.uint32(82).string(message.weeklyReportTimezone);
    }
    if (message.hasAtk !== undefined) {
      writer.uint32(88).bool(message.hasAtk);
    }
    if (message.uuid !== "") {
      writer.uint32(98).string(message.uuid);
    }
    if (message.isCarbon !== undefined) {
      writer.uint32(104).bool(message.isCarbon);
    }
    writer.uint32(114).fork();
    for (const v of message.productsUsed) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.db = DB.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sfdcAccountId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.emails.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = CustomerResponse_FeatureFlagsEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.featureFlags[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.weeklyReportHour = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.weeklyReportDay = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.weeklyReportEnabled = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.weeklyReportLookbackDays = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.weeklyReportTimezone = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.hasAtk = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isCarbon = reader.bool();
          continue;
        }
        case 14: {
          if (tag === 112) {
            message.productsUsed.push(reader.int32() as any);

            continue;
          }

          if (tag === 114) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.productsUsed.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomerResponse {
    return {
      db: isSet(object.db) ? DB.fromJSON(object.db) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      sfdcAccountId: isSet(object.sfdcAccountId)
        ? globalThis.String(object.sfdcAccountId)
        : isSet(object.sfdc_account_id)
        ? globalThis.String(object.sfdc_account_id)
        : "",
      emails: globalThis.Array.isArray(object?.emails) ? object.emails.map((e: any) => globalThis.String(e)) : [],
      featureFlags: isObject(object.featureFlags)
        ? (globalThis.Object.entries(object.featureFlags) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.feature_flags)
        ? (globalThis.Object.entries(object.feature_flags) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      weeklyReportHour: isSet(object.weeklyReportHour)
        ? globalThis.Number(object.weeklyReportHour)
        : isSet(object.weekly_report_hour)
        ? globalThis.Number(object.weekly_report_hour)
        : 0,
      weeklyReportDay: isSet(object.weeklyReportDay)
        ? globalThis.Number(object.weeklyReportDay)
        : isSet(object.weekly_report_day)
        ? globalThis.Number(object.weekly_report_day)
        : 0,
      weeklyReportEnabled: isSet(object.weeklyReportEnabled)
        ? globalThis.Boolean(object.weeklyReportEnabled)
        : isSet(object.weekly_report_enabled)
        ? globalThis.Boolean(object.weekly_report_enabled)
        : false,
      weeklyReportLookbackDays: isSet(object.weeklyReportLookbackDays)
        ? globalThis.Number(object.weeklyReportLookbackDays)
        : isSet(object.weekly_report_lookback_days)
        ? globalThis.Number(object.weekly_report_lookback_days)
        : 0,
      weeklyReportTimezone: isSet(object.weeklyReportTimezone)
        ? globalThis.String(object.weeklyReportTimezone)
        : isSet(object.weekly_report_timezone)
        ? globalThis.String(object.weekly_report_timezone)
        : "",
      hasAtk: isSet(object.hasAtk)
        ? globalThis.Boolean(object.hasAtk)
        : isSet(object.has_atk)
        ? globalThis.Boolean(object.has_atk)
        : undefined,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      isCarbon: isSet(object.isCarbon)
        ? globalThis.Boolean(object.isCarbon)
        : isSet(object.is_carbon)
        ? globalThis.Boolean(object.is_carbon)
        : undefined,
      productsUsed: globalThis.Array.isArray(object?.productsUsed)
        ? object.productsUsed.map((e: any) => productFromJSON(e))
        : globalThis.Array.isArray(object?.products_used)
        ? object.products_used.map((e: any) => productFromJSON(e))
        : [],
    };
  },

  toJSON(message: CustomerResponse): unknown {
    const obj: any = {};
    if (message.db !== undefined) {
      obj.db = DB.toJSON(message.db);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.sfdcAccountId !== "") {
      obj.sfdcAccountId = message.sfdcAccountId;
    }
    if (message.emails?.length) {
      obj.emails = message.emails;
    }
    if (message.featureFlags) {
      const entries = globalThis.Object.entries(message.featureFlags) as [string, boolean][];
      if (entries.length > 0) {
        obj.featureFlags = {};
        entries.forEach(([k, v]) => {
          obj.featureFlags[k] = v;
        });
      }
    }
    if (message.weeklyReportHour !== 0) {
      obj.weeklyReportHour = Math.round(message.weeklyReportHour);
    }
    if (message.weeklyReportDay !== 0) {
      obj.weeklyReportDay = Math.round(message.weeklyReportDay);
    }
    if (message.weeklyReportEnabled !== false) {
      obj.weeklyReportEnabled = message.weeklyReportEnabled;
    }
    if (message.weeklyReportLookbackDays !== 0) {
      obj.weeklyReportLookbackDays = Math.round(message.weeklyReportLookbackDays);
    }
    if (message.weeklyReportTimezone !== "") {
      obj.weeklyReportTimezone = message.weeklyReportTimezone;
    }
    if (message.hasAtk !== undefined) {
      obj.hasAtk = message.hasAtk;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.isCarbon !== undefined) {
      obj.isCarbon = message.isCarbon;
    }
    if (message.productsUsed?.length) {
      obj.productsUsed = message.productsUsed.map((e) => productToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomerResponse>, I>>(base?: I): CustomerResponse {
    return CustomerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomerResponse>, I>>(object: I): CustomerResponse {
    const message = createBaseCustomerResponse();
    message.db = (object.db !== undefined && object.db !== null) ? DB.fromPartial(object.db) : undefined;
    message.name = object.name ?? "";
    message.sfdcAccountId = object.sfdcAccountId ?? "";
    message.emails = object.emails?.map((e) => e) || [];
    message.featureFlags = (globalThis.Object.entries(object.featureFlags ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.weeklyReportHour = object.weeklyReportHour ?? 0;
    message.weeklyReportDay = object.weeklyReportDay ?? 0;
    message.weeklyReportEnabled = object.weeklyReportEnabled ?? false;
    message.weeklyReportLookbackDays = object.weeklyReportLookbackDays ?? 0;
    message.weeklyReportTimezone = object.weeklyReportTimezone ?? "";
    message.hasAtk = object.hasAtk ?? undefined;
    message.uuid = object.uuid ?? "";
    message.isCarbon = object.isCarbon ?? undefined;
    message.productsUsed = object.productsUsed?.map((e) => e) || [];
    return message;
  },
};

function createBaseCustomerResponse_FeatureFlagsEntry(): CustomerResponse_FeatureFlagsEntry {
  return { key: "", value: false };
}

export const CustomerResponse_FeatureFlagsEntry: MessageFns<CustomerResponse_FeatureFlagsEntry> = {
  encode(message: CustomerResponse_FeatureFlagsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomerResponse_FeatureFlagsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomerResponse_FeatureFlagsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomerResponse_FeatureFlagsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: CustomerResponse_FeatureFlagsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomerResponse_FeatureFlagsEntry>, I>>(
    base?: I,
  ): CustomerResponse_FeatureFlagsEntry {
    return CustomerResponse_FeatureFlagsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomerResponse_FeatureFlagsEntry>, I>>(
    object: I,
  ): CustomerResponse_FeatureFlagsEntry {
    const message = createBaseCustomerResponse_FeatureFlagsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseCustomer(): Customer {
  return { uuid: "", name: "" };
}

export const Customer: MessageFns<Customer> = {
  encode(message: Customer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Customer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Customer {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: Customer): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Customer>, I>>(base?: I): Customer {
    return Customer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Customer>, I>>(object: I): Customer {
    const message = createBaseCustomer();
    message.uuid = object.uuid ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseListCustomersRequest(): ListCustomersRequest {
  return { pageToken: "" };
}

export const ListCustomersRequest: MessageFns<ListCustomersRequest> = {
  encode(message: ListCustomersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCustomersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCustomersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCustomersRequest {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
    };
  },

  toJSON(message: ListCustomersRequest): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCustomersRequest>, I>>(base?: I): ListCustomersRequest {
    return ListCustomersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCustomersRequest>, I>>(object: I): ListCustomersRequest {
    const message = createBaseListCustomersRequest();
    message.pageToken = object.pageToken ?? "";
    return message;
  },
};

function createBaseListCustomersResponse(): ListCustomersResponse {
  return { customers: [], nextPageToken: "" };
}

export const ListCustomersResponse: MessageFns<ListCustomersResponse> = {
  encode(message: ListCustomersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.customers) {
      Customer.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== "") {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCustomersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCustomersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customers.push(Customer.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCustomersResponse {
    return {
      customers: globalThis.Array.isArray(object?.customers)
        ? object.customers.map((e: any) => Customer.fromJSON(e))
        : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
    };
  },

  toJSON(message: ListCustomersResponse): unknown {
    const obj: any = {};
    if (message.customers?.length) {
      obj.customers = message.customers.map((e) => Customer.toJSON(e));
    }
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCustomersResponse>, I>>(base?: I): ListCustomersResponse {
    return ListCustomersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCustomersResponse>, I>>(object: I): ListCustomersResponse {
    const message = createBaseListCustomersResponse();
    message.customers = object.customers?.map((e) => Customer.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
